export async function getDriverMethodCollectingUseCase(repository, driverId) {
  return repository.getByDriverId(driverId);
}
